import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import './Home.css';
import thailandImg from '../assets/images/places/1098.jpg';
import vieLanternImg from '../assets/images/places/lanterns.jpg';
import vieLakeImg from '../assets/images/places/vei-river.jpg';


function SpiceBar({ level }) {
  return (
    <div className="spice-bar">
      {[1,2,3,4,5].map(i => (
        <span key={i} className={`spice-dot ${i <= level ? 'spice-dot--on' : ''}`} />
      ))}
    </div>
  );
}

export default function Home() {
  const { data } = useData();
  const [videoLoaded, setVideoLoaded] = useState(false);

  return (
    <div className="home">

      {/* ── HERO WITH VIDEO ── */}
      <section className="hero">
        <div className="hero__video-wrap">
         <video
  className={`hero__video ${videoLoaded ? 'hero__video--loaded' : ''}`}
  autoPlay
  muted
  loop
  playsInline
  onCanPlay={() => setVideoLoaded(true)}
>
  <source src="https://res.cloudinary.com/demo/video/upload/v1/samples/elephants.mp4" type="video/mp4" />
</video>
          <div className="hero__video-fallback" />
        </div>
        <div className="hero__overlay" />
        <div className="hero__overlay-gradient" />

        <div className="hero__content">
          <div className="hero__brand-pill">✦ Mishti Holidays × Onaara Tours ✦</div>
          <h1 className="hero__title playfair">
            Your Journey,<br /><em>Our Passion</em>
          </h1>
          <p className="hero__tagline">Unforgettable Places · Warm People · Timeless Memories</p>
          <p className="hero__sub">
            Tailor-made Sri Lanka holidays crafted by local experts in Aluthgama.
            From tropical beaches to ancient kingdoms — discover it all.
          </p>
          <div className="hero__btns">
            <Link to="/packages" className="btn-primary">Explore Packages ✦</Link>
            <Link to="/places" className="btn-outline-white">Our Destinations</Link>
          </div>

          <div className="hero__contact-strip">
            <a href="tel:9740749793" className="hero__phone">📞 9740749793</a>
            <span className="hero__divider">|</span>
            <a href="tel:9483549793" className="hero__phone">📞 9483549793</a>
            <span className="hero__divider">|</span>
            <span className="hero__whatsapp">💬 WhatsApp Available</span>
          </div>
        </div>

        <div className="hero__stats">
          {[
            ['25+','Destinations'],
            ['100%','Tailor Made'],
            ['24/7','Support'],
            ['5★','Service'],
          ].map(([n,l]) => (
            <div key={l} className="hero__stat">
              <div className="hero__stat-num">{n}</div>
              <div className="hero__stat-label">{l}</div>
            </div>
          ))}
        </div>

        <div className="hero__scroll">
          <div className="hero__scroll-line" />
          <span>Scroll</span>
        </div>
      </section>

      {/* ── PACKAGE TYPES ── */}
      <section className="home__pkg-types">
        <div className="home__pkg-types-inner">
          <p className="section-eyebrow" style={{textAlign:'center'}}>✦ Holiday Packages For</p>
          <h2 className="section-title playfair" style={{textAlign:'center',color:'#fff'}}>What Kind of Journey Is Yours?</h2>
          <div className="pkg-types-grid">
            {[
              { icon:'💑', label:'Honeymoon Packages', desc:'Romantic Getaways · Scenic Beauty · Luxury Stays', color:'#c0392b', link:'/packages' },
              { icon:'👨‍👩‍👧‍👦', label:'Family Trip Packages', desc:'Fun for Everyone · Kid Friendly · Beautiful Memories', color:'#1565C0', link:'/packages' },
              { icon:'💼', label:'Corporate Tours', desc:'Meetings · Incentives · Conferences · Team Building', color:'#2E7D32', link:'/packages' },
              { icon:'🗺️', label:'Custom Itineraries', desc:'Tailor Made · Any Duration · Any Budget', color:'#6A1B9A', link:'/packages' },
            ].map(p => (
              <Link key={p.label} to={p.link} className="pkg-type-card" style={{'--accent': p.color}}>
                <div className="pkg-type-card__icon">{p.icon}</div>
                <h3 className="playfair">{p.label}</h3>
                <p>{p.desc}</p>
                <span className="pkg-type-card__arrow">→</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── PLACES ── */}
      <section className="section" style={{background:'var(--ivory)'}}>
        <div className="section-header">
          <p className="section-eyebrow">✦ Top Attractions</p>
          <h2 className="section-title playfair">Iconic Sri Lanka Destinations</h2>
          <p className="section-sub">Beautiful Beaches · Cultural Heritage · Wildlife Safaris · Shopping & Cuisine</p>
        </div>
        <div className="places-masonry">
          {data.places.slice(0, 6).map((place, i) => (
            <div key={place.id} className={`place-tile ${i === 0 ? 'place-tile--large' : ''}`}>
              <img src={place.image} alt={place.name} className="place-tile__img" loading="lazy" />
              <div className="place-tile__overlay" />
              <div className="place-tile__content">
                <span className="badge badge-gold">{place.badge}</span>
                <h3 className="playfair place-tile__name">{place.name}</h3>
                <p className="place-tile__desc">{place.desc}</p>
                <div className="place-tile__rating">★ {place.rating}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{textAlign:'center',marginTop:48}}>
          <Link to="/places" className="btn-secondary">View All {data.places.length} Destinations →</Link>
        </div>
      </section>

      {/* ── WHY US ── */}
      <section className="home__why">
        <div className="home__why-bg" />
        <div className="home__why-inner">
          <div className="home__why-text">
            <p className="section-eyebrow" style={{color:'var(--gold)'}}>✦ Why Choose Us</p>
            <h2 className="section-title playfair" style={{color:'#fff'}}>Simply Amazing Holidays Since 2012</h2>
            <p style={{color:'rgba(255,255,255,.65)',lineHeight:1.8,marginBottom:32}}>
  Based in Bangalore, India — in collaboration with Onaara Tours, Aluthgama Sri Lanka.
  We craft every holiday with personal care, local expertise, and genuine passion.
  No templates, no shortcuts — just real, unforgettable experiences.
</p>
            <div className="home__why-features">
              {[
                ['🧑‍✈️','Friendly & Professional Team'],
                ['🚗','Comfortable Transport Facilities'],
                ['🏨','Handpicked Hotels & Resorts'],
                ['🛡️','Safe, Reliable & Hassle Free Travel'],
              ].map(([icon, text]) => (
                <div key={text} className="home__why-feat">
                  <span>{icon}</span><span>{text}</span>
                </div>
              ))}
            </div>
            <div className="home__why-contact">
              <a href="tel:9740749793" className="btn-primary">📞 Call Now: 9740749793</a>
            </div>
          </div>
          <div className="home__why-img-grid">
            <img src="https://images.unsplash.com/photo-1609766857929-d87f3d667c94?w=600&q=80" alt="Sigiriya" className="why-img why-img--1" />
            <img src="https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=600&q=80" alt="Beach" className="why-img why-img--2" />
            <img src="https://images.unsplash.com/photo-1561731216-c3a4d99437d5?w=600&q=80" alt="Elephant" className="why-img why-img--3" />
          </div>
        </div>
      </section>

      {/* ── PACKAGES PREVIEW ── */}
      <section className="section" style={{background:'#fff'}}>
        <div className="section-header">
          <p className="section-eyebrow">✦ Packages</p>
          <h2 className="section-title playfair">Tailored Holiday Experiences</h2>
          <p className="section-sub">Honeymoon, family, corporate, or custom — we craft the perfect Sri Lanka experience for you.</p>
        </div>
        <div className="home__pkg-grid">
          {data.packages.map(pkg => (
            <div key={pkg.id} className="home-pkg-card">
              <div className="home-pkg-card__img-wrap">
                <img src={pkg.image} alt={pkg.name} className="home-pkg-card__img" loading="lazy" />
                <div className="home-pkg-card__img-overlay" />
                {pkg.tag && <span className="home-pkg-card__tag">{pkg.tag}</span>}
                <div className="home-pkg-card__days">{pkg.days} Days</div>
              </div>
              <div className="home-pkg-card__body">
                <div className="home-pkg-card__type">{pkg.type}</div>
                <h3 className="playfair home-pkg-card__name">{pkg.name}</h3>
                <p className="home-pkg-card__highlight">✦ {pkg.highlights}</p>
                <ul className="home-pkg-card__includes">
                  {pkg.includes.slice(0,3).map((inc,i) => <li key={i}>{inc}</li>)}
                </ul>
                <Link to="/contact" className="btn-primary" style={{width:'100%',justifyContent:'center',marginTop:16}}>
                  Book This Package
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── FOOD ── */}
      <section className="section" style={{background:'var(--sand)'}}>
        <div className="section-header">
          <p className="section-eyebrow">✦ Cuisine</p>
          <h2 className="section-title playfair">A Feast of Sri Lankan Flavours</h2>
          <p className="section-sub">Shopping & Cuisine — explore the vibrant food culture of the Pearl of the Indian Ocean.</p>
        </div>
        <div className="grid-3" style={{gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))'}}>
          {data.foods.slice(0, 3).map(f => (
            <div key={f.id} className="food-img-card">
              <div className="food-img-card__img-wrap">
                <img src={f.image} alt={f.name} className="food-img-card__img" loading="lazy" />
              </div>
              <div className="food-img-card__body">
                <h4 className="playfair food-img-card__name">{f.name}</h4>
                <p className="food-img-card__desc">{f.desc}</p>
                <div className="food-img-card__spice">
                  <span>Spice</span>
                  <SpiceBar level={f.spice} />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={{textAlign:'center',marginTop:40}}>
          <Link to="/food" className="btn-secondary">Explore All Dishes →</Link>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="home__cta">
        <div className="home__cta-inner">
          <p className="section-eyebrow" style={{color:'var(--gold)'}}>✦ Ready to Travel?</p>
          <h2 className="section-title playfair">Start Your Sri Lanka Journey Today</h2>
          <p style={{color:'var(--muted)',lineHeight:1.7,marginBottom:12}}>
            Call or WhatsApp us — our local experts will craft your perfect itinerary.
          </p>
          <div className="home__cta-phones">
            <a href="tel:9740749793" className="cta-phone">📞 9740749793</a>
            <a href="tel:9483549793" className="cta-phone">📞 9483549793</a>
          </div>
          <div style={{display:'flex',gap:14,justifyContent:'center',flexWrap:'wrap',marginTop:28}}>
            <Link to="/contact" className="btn-primary">Get a Free Quote →</Link>
            <Link to="/packages" className="btn-secondary">Browse Packages</Link>
          </div>
        </div>
      </section>

      {/* ── INTERNATIONAL BANNER ── */}
      <section className="home__intl-banner">
        <div className="home__intl-banner__inner">
          <div className="home__intl-banner__text">
            <p className="section-eyebrow" style={{color:'var(--gold)'}}>✦ We Also Cover</p>
            <h2 className="playfair home__intl-banner__title">
              Other International Holiday Packages
            </h2>
            <p className="home__intl-banner__sub">
              Beyond Sri Lanka, Mishti Holidays crafts unforgettable holidays
              across Southeast Asia. From the golden temples of Thailand to the
              emerald bays of Vietnam — we plan it all.
            </p>
            <div className="home__intl-banner__countries">
              {[
                // { flag:'🇱🇰', name:'Sri Lanka' },
                { flag:'🇹🇭', name:'Thailand' },
                { flag:'🇻🇳', name:'Vietnam' },
                // { flag:'🇸🇬', name:'Singapore' },
                // { flag:'🇲🇾', name:'Malaysia' },
                // { flag:'🇮🇩', name:'Bali' },
                // { flag:'🇦🇪', name:'Dubai' },
              ].map(c => (
                <div key={c.name} className="home__intl-country">
                  <span>{c.flag}</span>
                  <span>{c.name}</span>
                </div>
              ))}
            </div>
            <a href="/international" className="btn-primary" style={{marginTop:28,display:'inline-flex'}}>
              Explore International Packages →
            </a>
          </div>
          <div className="home__intl-banner__imgs">
            <img
              src={thailandImg}
              alt="Thailand"
              className="home__intl-img home__intl-img--1"
            />
            <img
              src={vieLanternImg}
              alt="Vietnam"
              className="home__intl-img home__intl-img--2"
            />
            <img
              src={vieLakeImg}
              alt="Vietnam"
              className="home__intl-img home__intl-img--3"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
